import React from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useChartToolbar } from "../../common/function/useChartToolbar";

interface Measurement {
  resistanceLeftAvr: number;
  resistanceRightAvr: number; 
}

interface ImpedanceRangeChartProps {
  xAxisData: string[];
  measurements: Measurement[];
  resistanceType: "left" | "right";
}

const ImpedanceRangeChart: React.FC<ImpedanceRangeChartProps> = ({ xAxisData, measurements, resistanceType  }) => {
  const toolbar = useChartToolbar();

  // Map the measurements to an array of resistanceLeftAvr values
  const seriesData = measurements.map((m) => {
    const resistance = resistanceType === "left" ? m.resistanceLeftAvr : m.resistanceRightAvr;
    if (resistance <= 10000) return 1;
    if (resistance > 10000 && resistance <= 50000) return 0.5;
    if (resistance > 50000) return 0.05;
    return 0; 
  });

  const [state] = React.useState<{
    options: ApexOptions;
    series: { name: string; data: number[] }[];
  }>(() => ({
    options: {
      chart: {
        id: "impedance-range-chart",
        toolbar,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "5px",
          borderRadius: 0,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: xAxisData,
        labels: {
          show: true,
          rotate: -45,
          style: {
            fontSize: "10px",
            colors: "#7B7484",
          },
        },
        tickAmount: 19,
      },
      yaxis: {
        title: {
          text: "Impedance (Range)",
          style: {
            fontSize: "12px",
            fontFamily: "Poppins",
            fontWeight: 400,
            color: "#202224",
          },
        },
        labels: {
          style: {
            fontSize: "12px",
            colors: "#7B7484",
          },
        },
        min: 0,
        max: 1,
        tickAmount: 2,
      },
      grid: {
        borderColor: "#E0E0E0",
        strokeDashArray: 2,
        position: "back",
      },
      colors: [
        ({ value }: { value: number }) => {
          if (value === 0.05) {
            return "#EF4444"; 
          } else if (value === 0.5) {
            return "#F59E0B";
          } else {
            return "#3B9CB9"; 
          }
        },
      ],
      tooltip: {
        enabled: true,
        theme: "light",
        x: {
          formatter: (val: string | number) => `Time: ${val}`,
        },
        y: {
          formatter: (val: number) => `${val.toFixed(2)} (Range)`,
        },
      },
    },
    series: [
      {
        name: "Impedance Range",
        data: seriesData,
      },
    ],
  }));

  return (
    <div style={{ position: "relative", width: "100%", height: "auto" }}>
      <Chart options={state.options} series={state.series} type="bar" height={567} />
    </div>
  );
};

export default ImpedanceRangeChart;
